import React from 'react';
import H3Text from '@Uilib/h3Text';
import { toISTDate } from '../../../../apis/constants';

const ListScreenKeys = ({ documentData }) => {
  const record = documentData;

  const createdBy = (
    <div>
      <H3Text text={toISTDate(record?.created_at).format('DD/MM/YYYY')} />
      <H3Text text={`${record?.created_by_info?.first_name || ''} ${record?.created_by_info?.last_name || ''}`} className="table-subscript" />
    </div>
  );

  return [
    {
      label: 'Reference #',
      value: record?.payment_status === 'PAYMENT_SUCCESS' ? record?.utr_number : '',
    },
    {
      label: 'Payment Account',
      value: record?.paid_through_account_details?.account_name === 'PICE' ? 'ONLINE' : record?.paid_through_account_details?.account_name || 'CASH',
    },
    {
      label: 'Created By',
      value: createdBy || '-',
    },
  ];
};

export {
  ListScreenKeys,
};
